module.exports = __webpack_public_path__ + "static/media/download.404ed721.svg";